import React from 'react'

const MainBackground = ({children}) => {
  return (
    <div className='main-bg'>
        {children}
    </div>
  )
}

export default MainBackground